import removeDuplicateQueryParams from 'utils/sourceAttributes'

const identifyQueryParam = (param: string, value?: string) => {
  if (!window.location.search) return false

  const params = removeDuplicateQueryParams(window.location.search)
  if (!params[param]) return false

  return value ? params[param] === value : !!params[param]
}

export const isClickId = () => identifyQueryParam('clickid')
export const isProgramReferral = () => identifyQueryParam('pdisc', 'aff')
export const isOneTimeToken = () => identifyQueryParam('oneTimeToken')
